import { Permission } from './modules'
import User from './user'

export default {
  has(requests) {
    return Permission.requests(requests).has(User.permissions || [])
  },
}



// WEBPACK FOOTER //
// ./client/src/permission.js